module.exports = __webpack_public_path__ + "static/img/200145.e60530c0.png";